import React from "react";
import { useSelector } from "react-redux";
import {
  formatCurrency,
  formatPhoneNumber,
  getCompanyTimeZone,
  getDSTAwareTimezoneAbbreviation,
  getTimezoneAbbreviation
} from "config/locationConfig";
import {
  formatAcademyDate,
  formatAcademyDateTime,
  formatDateInCompanyTimeZone
} from "utils/format";

const FormatByOperatingLocation = ({ value, type = "TEXT", company }) => {
  const companyDetails = useSelector((state) => state?.companyReducer?.company);
  const resolvedCompanyDetails = company || companyDetails;

  const formatValueByType = () => {
    switch (type) {
      case "PHONE":
        return formatPhoneNumber(value, resolvedCompanyDetails);

      case "CURRENCY":
        return formatCurrency(value, resolvedCompanyDetails);

      case "DATE":
        return formatAcademyDate(value);

      case "DATE_TIME":
      case "DATETIME":
        return formatAcademyDateTime(value);

      case "TIMEZONE_DATE":
        return formatDateInCompanyTimeZone(value, resolvedCompanyDetails);

      case "TIMEZONE":
        return getDSTAwareTimezoneAbbreviation(getCompanyTimeZone(resolvedCompanyDetails));

      default:
        return value || "-";
    }
  };

  return <span>{formatValueByType()}</span>;
};

export { getDSTAwareTimezoneAbbreviation, getTimezoneAbbreviation };

export default FormatByOperatingLocation;
